import { Avatar } from 'primereact/avatar'
import type { ReactElement } from 'react'

export function CardHeader(props: { title: string; imagePlaceholder?: string }): ReactElement {
  return (
    <div className='grid min-h-[72px] grid-cols-12 lg:min-h-[72px] xl:min-h-[42px]'>
      <div className='col-span-11'>{props.title}</div>
      {props.imagePlaceholder && (
        <div className='align-center col-span-1 text-right'>
          <Avatar image={props.imagePlaceholder} size='normal' shape='circle' />
        </div>
      )}
    </div>
  )
}
